import { RecommendedChannelsTray } from '../../../domain/recommended-channels-tray';
import { CreateRecommendedChannelsPageItemRequestApiModel, UpdateRecommendedChannelsPageItemRequestApiModel } from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  mapChannelDomainModelToApiModel,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import { RecommendedChannelsPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import {
  commonMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { RecommendedChannelsTrayViewModel } from './recommended-channels-tray.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'RecommendedChannelsTray'

/**
 * DOMAIN -> API
 */

export const mapRecommendedChannelsTrayDomainModelToApiModel = (
  item: RecommendedChannelsTray,
  pageVersionId?: string,
  tenantId?: string
): CreateRecommendedChannelsPageItemRequestApiModel & UpdateRecommendedChannelsPageItemRequestApiModel => {
  const commonProperties = mapperPipe(item, nameLocalizedMapperDomainToApi, targetingMapperDomainToApi, scheduledDateMapperDomainToApi);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    items: item.items.map(mapChannelDomainModelToApiModel),
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapRecommendedChannelsTrayApiModelToDomainModel = (pageItem: RecommendedChannelsPageItemApiModel): RecommendedChannelsTray => {
  return remainderMapper(
    mapperPipe(pageItem, commonMapper, nameLocalizedMapperApiToDomain, targetingMapperApiToDomain, scheduledDateMapperApiToDomain),
    () => ({
      type: 'RecommendedChannelsTray',
      items: pageItem.items
        .sort((s) => s.order)
        .map((item) => ({
          id: item.id,
          order: item.order,
          channel: {
            id: item.channel.id,
            channelID: item.channel.channelId,
            channelName: item.channel.channelName,
            channelNumber: item.channel.channelNumber,
          },
        })),
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapRecommendedChannelsTrayDomainModelToViewModel = (pageItem: RecommendedChannelsTray): RecommendedChannelsTrayViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.RecommendedChannelsTray,
    items: pageItem.items.map((item, index) => ({
      id: item.id,
      index,
      order: item.order,
      name: undefined,
      channel: item.channel,
    })),
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapRecommendedChannelsTrayViewModelToDomainModel = (vm: RecommendedChannelsTrayViewModel): RecommendedChannelsTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain
  );

  return remainderMapper(commonProperties, () => ({
    type: 'RecommendedChannelsTray',
    items: vm.items.map((item, index) => ({
      id: item.id,
      order: index,
      channel: item.channel,
    })),
  }));
};
